/**
 * Marks the history entry the app was loaded on, so goBack knows there is no in-app page behind it
 */
export const markAppEntry = () => {
  // A reload or back/forward restores a deeper entry whose history.state already says whether it was the entry
  if (performance.getEntriesByType("navigation")[0]?.type !== "navigate") {
    return;
  }

  window.history.replaceState({ ...window.history.state, appEntry: true }, "");
};

/**
 * Goes to the previous page, or to the resource list (or the dashboard when there is none) when the app was opened on this page
 * @param {VueRouter} router
 */
export const goBack = router => {
  if (!window.history.state?.appEntry) {
    router.back();

    return;
  }

  const listName = `${router.currentRoute.meta.resource}_list`;
  const hasList = router.getRoutes().some(({ name }) => name === listName);

  router.push({ name: hasList ? listName : "dashboard" });
};
